import { IRateData } from 'types/administration/pricing/underwriterProfileInterfaces/IRate';
import React from 'react';
import { KeyObjectViewer } from './LabelValueViewer';
import { IBracketData } from 'types/administration/pricing/underwriterProfileInterfaces/IBracket';
import { IScheduleData } from 'types/administration/pricing/underwriterProfileInterfaces/ISchedule';
import { BodyText, BoldBodyText, Card, Currency, Grid } from 'ui-toolkit/components';
import styled from 'styled-components';
import { GrayCard } from './GrayCard';

interface IRateViewerProps {
  rate: IRateData;
  title: string;
  multiplier?: number;
}

export const RateViewer: React.FC<IRateViewerProps> = ({ rate, title, multiplier }) => (
  <GrayCard title={title} isCollapsible>
    <KeyObjectViewer label={'brackets' in rate ? 'Brackets' : 'Schedules'}>
      <Card>
        <Grid templateColumns={'max-content 1fr'}>
          <Grid>
            {'brackets' in rate
              ? rate.brackets.map((bracket) => (
                  <BoldRightAlign key={bracket.rangeFrom}>{generateRangeData(bracket)}:</BoldRightAlign>
                ))
              : rate.schedules.map((schedule) => (
                  <BoldRightAlign key={schedule.rangeFrom}>{generateRangeData(schedule)}:</BoldRightAlign>
                ))}
            {}
          </Grid>
          <Grid>
            {'brackets' in rate
              ? rate.brackets.map((bracket) => (
                  <Currency key={bracket.rangeFrom} value={bracket.price * (multiplier || 1)} />
                ))
              : rate.schedules.map((schedule) => (
                  <BodyText key={schedule.rangeFrom}>{schedule.percent * (multiplier || 1)}</BodyText>
                ))}
          </Grid>
        </Grid>
      </Card>
    </KeyObjectViewer>
  </GrayCard>
);

const generateRangeData = ({ rangeFrom, rangeTo }: IBracketData | IScheduleData): string => `${rangeFrom} - ${rangeTo}`;

const BoldRightAlign = styled(BoldBodyText)`
  text-align: end;
`;
